"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HeaderNav = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _antd = require("antd");

var _icons = require("@ant-design/icons");

var _Logo = _interopRequireDefault(require("./Logo"));

var _reactRouterDom = require("react-router-dom");

var _NavSearch = _interopRequireDefault(require("./NavSearch"));

var _Theme = require("../../redux/actions/Theme");

var _ThemeConstant = require("../../constants/ThemeConstant");

var _utils = _interopRequireDefault(require("../../utils"));

var Header = _antd.Layout.Header;

var HeaderNav = function HeaderNav(props) {
  var navCollapsed = props.navCollapsed,
      mobileNav = props.mobileNav,
      navType = props.navType,
      headerNavColor = props.headerNavColor,
      toggleCollapsedNav = props.toggleCollapsedNav,
      onMobileNavToggle = props.onMobileNavToggle,
      isMobile = props.isMobile,
      currentTheme = props.currentTheme;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      searchActive = _useState2[0],
      setSearchActive = _useState2[1];

  var history = (0, _reactRouterDom.useHistory)();

  var onSearchClose = function onSearchClose() {
    setSearchActive(false);
  };

  var onToggle = function onToggle() {
    if (!isMobile) {
      toggleCollapsedNav(!navCollapsed);
    } else {
      onMobileNavToggle(!mobileNav);
    }
  };

  var isNavTop = navType === _ThemeConstant.NAV_TYPE_TOP ? true : false;

  var mode = function mode() {
    if (!headerNavColor) {
      return _utils.default.getColorContrast(currentTheme === 'dark' ? '#00000' : '#ffffff');
    }

    return _utils.default.getColorContrast(headerNavColor);
  };

  var navMode = mode();

  var getNavWidth = function getNavWidth() {
    if (isNavTop || isMobile) {
      return '0px';
    }

    if (navCollapsed) {
      return "".concat(_ThemeConstant.SIDE_NAV_COLLAPSED_WIDTH, "px");
    } else {
      return "".concat(_ThemeConstant.SIDE_NAV_WIDTH, "px");
    }
  };

  (0, _react.useEffect)(function () {
    if (!isMobile) {
      onSearchClose();
    }
  });

  var menu = /*#__PURE__*/_react.default.createElement(_antd.Menu, null, /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, {
    key: "2"
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    target: "_blank",
    onClick: logOut
  }, "Log Out")));

  function logOut() {
    localStorage.setItem("CL", "");
    localStorage.setItem("token", null);
    history.push('/clPortal/auth/login');
  }

  return /*#__PURE__*/_react.default.createElement(Header, {
    className: "app-header ".concat(navMode),
    style: {
      backgroundColor: headerNavColor
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "app-header-wrapper ".concat(isNavTop ? 'layout-top-nav' : '')
  }, /*#__PURE__*/_react.default.createElement(_Logo.default, {
    logoType: navMode
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "nav",
    style: {
      width: "calc(100% - ".concat(getNavWidth(), ")")
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "nav-left"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "ant-menu ant-menu-root ant-menu-horizontal"
  }, isNavTop && !isMobile ? null : /*#__PURE__*/_react.default.createElement("li", {
    className: "ant-menu-item ant-menu-item-only-child",
    onClick: function onClick() {
      onToggle();
    }
  }, navCollapsed || isMobile ? /*#__PURE__*/_react.default.createElement(_icons.MenuUnfoldOutlined, {
    className: "nav-icon"
  }) : /*#__PURE__*/_react.default.createElement(_icons.MenuFoldOutlined, {
    className: "nav-icon"
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "nav-right"
  }, /*#__PURE__*/_react.default.createElement(_antd.Dropdown, {
    overlay: menu
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    className: "ant-dropdown-link",
    style: {
      fontSize: '18px'
    }
  }, "Log out \xA0", /*#__PURE__*/_react.default.createElement(_icons.LogoutOutlined, null)))), /*#__PURE__*/_react.default.createElement(_NavSearch.default, {
    active: searchActive,
    close: onSearchClose
  }))));
};

exports.HeaderNav = HeaderNav;

var mapStateToProps = function mapStateToProps(_ref) {
  var theme = _ref.theme;
  var navCollapsed = theme.navCollapsed,
      navType = theme.navType,
      headerNavColor = theme.headerNavColor,
      mobileNav = theme.mobileNav,
      currentTheme = theme.currentTheme;
  return {
    navCollapsed: navCollapsed,
    navType: navType,
    headerNavColor: headerNavColor,
    mobileNav: mobileNav,
    currentTheme: currentTheme
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  toggleCollapsedNav: _Theme.toggleCollapsedNav,
  onMobileNavToggle: _Theme.onMobileNavToggle
})(HeaderNav);

exports.default = _default;